import React from "react";
import { Images } from "assets";
import styles from "./style.module.scss";

interface BrandingBandProps {
  name: string;
  subtitle?: string;
}

/** School identity band — uses the same brand logo as the sidebar. */
export default function BrandingBand({
  name,
  subtitle = "Head Office Dashboard",
}: BrandingBandProps) {
  return (
    <div className={styles.band}>
      <div className={styles.logoBox}>
        <Images.Logo className={styles.logo} />
      </div>
      <div className={styles.text}>
        <span className={styles.name} data-ho-blur="school">
          {name}
        </span>
        <div className={styles.sub}>{subtitle}</div>
      </div>
    </div>
  );
}
